/**
 * Wall-clock value of `<input type="datetime-local">`: `YYYY-MM-DDTHH:mm`
 * in the browser's local timezone, with no seconds and no am/pm.
 * `fromDatetimeLocal` / `toDatetimeLocal` keep the referral Sendt conversion:
 * that string in, ISO instant out, and back.
 */
const WALL = /^(\d{4}-\d{2}-\d{2})T([01]\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/;

export function splitDatetimeLocal(value: string): { date: string; time: string } {
  const match = WALL.exec(value.trim());
  if (!match) return { date: '', time: '' };
  return { date: match[1], time: `${match[2]}:${match[3]}` };
}

export function joinDatetimeLocal(date: string, time: string): string {
  const clock = time.trim().slice(0, 5);
  const joined = `${date.trim()}T${clock}`;
  return WALL.test(joined) ? joined.slice(0, 16) : '';
}

export function fromDatetimeLocal(value: string): string | null {
  if (!value.trim()) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}

export function toDatetimeLocal(iso: string | null): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
